import React, { useState } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import fr from "date-fns/locale/fr";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import { Calendar } from "lucide-react";

registerLocale("fr", fr);

const DateSelector = ({ getDate, date = new Date() }) => {
  const [selectedDate, setSelectedDate] = useState(date);
  const [isOpen, setIsOpen] = useState(false);

  const handleDateChange = (d) => {
    setSelectedDate(d);
    setIsOpen(false);
    if (getDate) getDate(d);
  };

  return (
    <div className="pr date-selector">
      <button type="button" onClick={() => setIsOpen(!isOpen)} className="date-input df aic gap1">
        <Calendar size={18} color="#000" />
        <span>{moment(selectedDate).format("DD / MM / YYYY")}</span>
      </button>

      {isOpen && (
        <div className="calendar-float">
          <DatePicker
            selected={selectedDate}
            onChange={handleDateChange}
            onClickOutside={() => setIsOpen(false)}
            locale="fr"
            inline
          />
        </div>
      )}
    </div>
  );
};

export default DateSelector;
